document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.c-variants-product__item-wrapper').forEach(wrapper => {
    const variants = Array.from(wrapper.querySelectorAll('.c-variants-product__variant'));
    const showMore = wrapper.querySelector('#show-more-variants');
    const disponibles = variants.filter(v => !v.querySelector('input').classList.contains('enable'));
    const sinStock = variants.filter(v => v.querySelector('input').classList.contains('enable'));

    variants.forEach(v => v.remove());
    disponibles.forEach(v => wrapper.insertBefore(v, showMore));
    sinStock.forEach(v => wrapper.insertBefore(v, showMore));
  });
});